import { IGroupCourse, IGroupCourseData, IGroupCourseItem, IGroupCourseParams, IGroupCourseStatus, IGroupCourseStudent, IGroupCourseTeacher, ITableRes } from 'types'
import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants';

export const groupCoursesAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    //GroupCourse
    GET_groupCourses: builder.query<ITableRes<IGroupCourseItem>, IGroupCourseParams>({
      query: (params) => ({
        url: '/group-courses/',
        params,
      }),
      providesTags: ['group-courses'],
    }),
    GET_groupCourseById: builder.query<IGroupCourse, string>({
      query: (id) => {
        return {
          url: `/group-courses/${id}/`,
        }
      },
      providesTags: ['group-course'],
    }),
    POST_groupCourse: builder.mutation<IGroupCourse, IGroupCourseData>({
      query: (body) => ({
        url: `/group-courses/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['group-courses', 'group-course'],
    }),
    PUT_groupCourse: builder.mutation<IGroupCourse, { id: string; body: IGroupCourseData }>({
      query: ({ id, body }) => ({
        url: `/group-courses/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['group-courses', 'group-course'],
    }),
    PATCH_groupCourse: builder.mutation<IGroupCourse, { id: string; body: IGroupCourseStatus }>({
      query: ({ id, body }) => ({
        url: `/group-courses/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['group-courses', 'group-course'],
    }),
    DELETE_groupCourse: builder.mutation<IGroupCourse, string>({
      query: (id) => ({
        url: `/group-courses/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['group-courses'],
    }),
    POST_groupCourseSchedule: builder.mutation<IGroupCourse, IGroupCourseData>({
      query: (body) => ({
        url: `/create-group-course-with-sessions/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['group-courses'],
    }),
    PUT_addTeacherToGroupCourse: builder.mutation<IGroupCourseTeacher, {id: string; teacher_id: string}>({
      query: ({id, teacher_id}) => ({
        url: `/group-courses/${id}/add-teacher-to-group-course/${teacher_id}/`,
        method: 'PUT',
      }),
      invalidatesTags: ['group-courses', 'teachers'],
    }),
    PUT_removeTeacherFromGroupCourse: builder.mutation<IGroupCourseTeacher, {id: string; teacher_id: string}>({
      query: ({id, teacher_id}) => ({
        url: `/group-courses/${id}/remove-teacher-from-group-course/${teacher_id}/`,
        method: 'PUT',
      }),
      invalidatesTags: ['group-courses', 'teachers'],
    }), 
    POST_createStudentsInGroupCourse: builder.mutation<any, any>({
      query: ({id, body}) => ({
        url: `/group-courses/${id}/create-students-in-group-course/`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['group-courses', 'students'],
    }),
    PUT_addStudentToGroupCourse: builder.mutation<IGroupCourseStudent, {id: string; student_id: string}>({
      query: ({id, student_id}) => ({
        url: `/group-courses/${id}/add-student-to-group-course/${student_id}/`,
        method: 'PUT',
      }),
      invalidatesTags: ['group-courses', 'students'],
    }),
    PUT_removeStudentFromGroupCourse: builder.mutation<IGroupCourseStudent, {id: string; student_id: string}>({
      query: ({id, student_id}) => ({
        url: `/group-courses/${id}/remove-student-from-group-course/${student_id}/`,
        method: 'PUT',
      }),
      invalidatesTags: ['group-courses', 'students'],
    }), 
    //Select
    GET_groupCourseSelect: builder.query<any, {group: number}>({
      query: (params) => ({
        url: '/group-courses/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['group-course-select'],
    }),
  }),
})

export const { 
  useGET_groupCoursesQuery, 
  useGET_groupCourseByIdQuery, 
  usePOST_groupCourseMutation, 
  usePUT_groupCourseMutation, 
  usePATCH_groupCourseMutation, 
  useDELETE_groupCourseMutation, 
  usePOST_groupCourseScheduleMutation, 
  usePUT_addTeacherToGroupCourseMutation, 
  usePUT_removeTeacherFromGroupCourseMutation, 
  usePUT_addStudentToGroupCourseMutation, 
  usePOST_createStudentsInGroupCourseMutation, 
  usePUT_removeStudentFromGroupCourseMutation, 
  useGET_groupCourseSelectQuery, 
} = groupCoursesAPI
